<template>
  <OrgSuspendedScreen v-if="suspension" />
  <router-view v-else />
</template>

<script setup lang="ts">
import { suspension } from '@hospora-bookings/shared-ui'
import OrgSuspendedScreen from './components/OrgSuspendedScreen.vue'
</script>
